import AACChromeAPI from '@amzn/aac-chrome-api';
import { getInternalChromeConfig } from 'src/commons/apis';
import { isFromTrim, shouldLoadSystemJsAssets } from 'src/commons/utils';
import { logger } from 'src/commons/utils/logger';

const loadHmh = (hmhUrl) => {
  if (shouldLoadSystemJsAssets()) {
    window.System.import(hmhUrl);
  } else {
    // System.import is not a function on Rodeo so need a backup way of loading the script
    const scriptEle = document.createElement('script');
    scriptEle.setAttribute('src', hmhUrl);
    scriptEle.setAttribute('type', 'text/javascript');
    scriptEle.setAttribute('id', 'hmh-bundle');
    scriptEle.defer = true;
    document.head.appendChild(scriptEle);
  }
};

export const loadHmhBundleScript = async (e?: any) => {
  const chromeConfig =
    e?.detail?.chromeConfiguration || AACChromeAPI.getChromeConfiguration();
  const hmhEnabled: boolean =
    chromeConfig.getHmhEnabled &&
    typeof chromeConfig.getHmhEnabled === 'function'
      ? chromeConfig.getHmhEnabled()
      : false;
  // todo: clean this up as HMH is fully dialed up and the script can be printed on the server side
  if (hmhEnabled) {
    // HMH can get loaded from the backend and this check ensures it has not been
    // TODO: Remove this check after the backend import is removed
    // sim: https://sim.amazon.com/issues/f7264960-d007-4933-9545-21064ca6f29c
    const hmhScriptExists = !!document.getElementById('hmh-bundle');
    // do not load HMH bundle for TrimService as it will be loaded on server side
    if (!hmhScriptExists && !isFromTrim()) {
      try {
        const internalChromeConfig = await getInternalChromeConfig();
        const hmhFeatureInfo =
          internalChromeConfig.featureLaunchInfo?.features.find(
            (feature) => feature.name === 'HMH' && feature.isEnabled,
          );
        // onLoad event is to ensure the DOM and window have finished loading before attempting to load HMH.
        if (hmhFeatureInfo?.content?.url) {
          const hmhUrl = hmhFeatureInfo.content.url;
          if (document.readyState === 'complete') {
            loadHmh(hmhUrl);
          } else {
            window.addEventListener('load', () => {
              loadHmh(hmhUrl);
            });
          }
        }
      } catch (e: any) {
        logger.error('failed to fetch chromeData:', e);
      }
    }

    AACChromeAPI.getCommonEventTarget().removeEventListener(
      'ChromeConfigurationChange',
      loadHmhBundleScript,
    );
  }
};
